// extracted by mini-css-extract-plugin
export default {"buttonClose":"ModalDeleteExam_buttonClose__cOcx7","iconCloseModal":"ModalDeleteExam_iconCloseModal__q7b6K"};